import { getAuthToken } from './authApi';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5215';

export const getInactiveUsers = async ({ thresholdDays, tenantKey } = {}) => {
  const token = getAuthToken();
  if (!token) throw new Error('Not authenticated');

  const params = new URLSearchParams();
  if (thresholdDays != null) params.append('thresholdDays', thresholdDays);
  if (tenantKey) params.append('tenantKey', tenantKey);

  const queryString = params.toString();
  const url = `${API_BASE_URL}/api/Users/GetInactiveUsers${queryString ? `?${queryString}` : ''}`;

  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const err = new Error(response.status === 401 ? 'Authentication required' : 'Failed to load inactive users');
    err.status = response.status;
    throw err;
  }

  return response.json();
};
